import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard/Index';
import Login from './pages/Login/Index';
import Users from './pages/DataManagement/Users/Index';
import DataManagement from './pages/DataManagement/SideBarNav/Index';

import Contractors from './pages/DataManagement/Contractors/Index';
import LoginProcess from './pages/Login/process/Index';
import Tenders from './pages/DataManagement/Tender/Index';
import StandardTerms from './pages/DataManagement/Terms/Standard/Index';
import AdHocTerms from './pages/DataManagement/Terms/AdHoc/Index';
import Customer from './pages/DataManagement/Customers/Index';
import Resources from './pages/DataManagement/Resource/Index';
import Billable from './pages/DataManagement/Billable/Index';
import BillableForm from './pages/DataManagement/Billable/Form';

import ContractorForm from './pages/DataManagement/Contractors/Form';
import CustomerForm from './pages/DataManagement/Customers/Form';
import StandardTermsForm from './pages/DataManagement/Terms/Standard/Form';
import AdHocTermsForm from './pages/DataManagement/Terms/AdHoc/Form';
import TendersForm from './pages/DataManagement/Tender/Form';
import ResourcesForm from './pages/DataManagement/Resource/Form';
import Project from './pages/DataManagement/Project/Index';
import ProjectForm from './pages/DataManagement/Project/ProjectForm';
import Inventory from './pages/Inventory/Index';
import ProjectDashboard from './pages/ProjectDashboard/Index';
import Scheduling from './pages/Schedule/Index';
import CompanyProfile from './pages/CompanyProfile/Index';
import LayoutDashboard from './pages/Quote/Layout';
import QuoteDashboard from './pages/Quote/Index';
import QuoteDialogComponent from './pages/Quote/QuoteForm';
import UsersFormCommon from './pages/DataManagement/Users/Form';
import Warehouses from './pages/DataManagement/Warehouses/Index';
import WarehouseForm from './pages/DataManagement/Warehouses/Form';
import SWMS from './pages/DataManagement/SWMS/Index';
import SWMSForm from './pages/DataManagement/SWMS/Form';
import Layout from './Layout';
import CriticalChecks from './pages/DataManagement/CriticalChecks/Index';
import CriticalCheckForm from './pages/DataManagement/CriticalChecks/Form';
import Labour from './pages/DataManagement/Labour/Index';
import LabourForm from './pages/DataManagement/Labour/Form';
import MobileAssets from './pages/DataManagement/MobileAssets/Index';
import MobileAssetForm from './pages/DataManagement/MobileAssets/Form';
import Crews from './pages/DataManagement/Crews/Index';
import CrewsForm from './pages/DataManagement/Crews/Form';
import CrewsDashboard from './pages/DataManagement/Crews/parts/CrewsDashboard';
import ProjectOverview from './pages/ProjectDashboard/ProjectOverview';
import CrewDashboard from './pages/CrewDashboard/Index';
import ShiftReport from './pages/CrewDashboard/ShiftReport';
import WareHouseOnSite from './pages/Inventory/Warehouse-OnSite';
import InventoryHistory from './pages/Inventory/InventoryHistory';
import EndOfMonth from './pages/Inventory/End-Of-Month';
import MaterialTransferPO from './pages/Inventory/Material-Transfer-PO';
import ReceiptingDetails from './pages/Inventory/ReceiptingDetails';
import CrewPack from './pages/CrewDashboard/CrewPack';
import ShiftPhotos from './pages/CrewDashboard/ShiftPhotos';
import ShiftSiteMemo from './pages/CrewDashboard/ShiftSiteMemo';
import ShiftMobilePrestart from './pages/CrewDashboard/ShiftMobilePrestart';
import ShiftNotes from './pages/CrewDashboard/ShiftNotes';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route path="/login" element={<Login />} />
        <Route path="" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/scheduling" element={<Scheduling />} />
        <Route path="/" element={<Inventory />} />
        <Route path="/inventory">
          <Route index element={<Inventory />} />
          <Route path="warehouse-onsite-inventory">
            <Route index element={<WareHouseOnSite />} />
            <Route path=":inventoryId" element={<InventoryHistory />} />
            <Route path=":crewId/:shiftId" element={<Inventory />} />
          </Route>
          <Route path="end-of-month">
            <Route index element={<EndOfMonth />} />
          </Route>
          <Route path="material-transfer-po">
            <Route index element={<MaterialTransferPO />} />
            <Route path=":currentId" element={<ReceiptingDetails />} />
          </Route>
        </Route>
        <Route path="/schedules">
          <Route index element={<CrewDashboard />} />
          <Route path="crews-schedule">
            <Route index element={<CrewDashboard />} />
            <Route path=":crewId" element={<ShiftReport />} />
            <Route path=":crewId/:shiftId" element={<CrewPack />} />
            <Route path="shift/:crewId" element={<ShiftReport />} />
            <Route path="shift/:crewId/:shiftId" element={<ShiftReport />} />
            <Route
              path="shift/:crewId/:shiftId/photos"
              element={<ShiftPhotos />}
            />
            <Route
              path="shift/:crewId/:shiftId/memo"
              element={<ShiftSiteMemo />}
            />
            <Route
              path="shift/:crewId/:shiftId/map"
              element={<ShiftMobilePrestart />}
            />
            <Route
              path="shift/:crewId/:shiftId/note"
              element={<ShiftNotes />}
            />
          </Route>
        </Route>
        <Route path="/project-dashboard/project">
          <Route index element={<ProjectDashboard />} />
          <Route path="">
            <Route index element={<ProjectDashboard />} />
            <Route path=":currentId" element={<ProjectOverview />} />
          </Route>
        </Route>
        <Route path="/quote-dashboard">
          <Route index element={<QuoteDashboard />} />
          <Route path="quote">
            <Route index element={<QuoteDashboard />} />
            <Route path=":quoteId" element={<QuoteDialogComponent />} />
          </Route>
        </Route>
        <Route path="/data-management">
          <Route index element={<DataManagement />} />
          <Route path="user">
            <Route index element={<Users />} />
            <Route path=":currentId" element={<UsersFormCommon />} />
          </Route>
          <Route path="contractor">
            <Route index element={<Contractors />} />
            <Route path=":currentId" element={<ContractorForm />} />
          </Route>
          <Route path="customer">
            <Route index element={<Customer />} />
            <Route path=":currentId" element={<CustomerForm />} />
          </Route>
          <Route path="standard-terms-conditions">
            <Route index element={<StandardTerms />} />
            <Route path=":currentId" element={<StandardTermsForm />} />
          </Route>
          <Route path="adhoc-terms-conditions">
            <Route index element={<AdHocTerms />} />
            <Route path=":currentId" element={<AdHocTermsForm />} />
          </Route>
          <Route path="tender">
            <Route index element={<Tenders />} />
            <Route path=":currentId" element={<TendersForm />} />
          </Route>
          <Route path="resource-items">
            <Route index element={<Resources />} />
            <Route path=":currentId" element={<ResourcesForm />} />
          </Route>
          <Route path="billable-items">
            <Route index element={<Billable />} />
            <Route path=":currentId" element={<BillableForm />} />
          </Route>
          <Route path="project-template">
            <Route index element={<Project />} />
            <Route path=":currentId" element={<ProjectForm />} />
          </Route>
          <Route path="warehouses">
            <Route index element={<Warehouses />} />
            <Route path=":currentId" element={<WarehouseForm />} />
          </Route>
          <Route path="swms">
            <Route index element={<SWMS />} />
            <Route path=":currentId" element={<SWMSForm />} />
          </Route>
          <Route path="critical-checks">
            <Route index element={<CriticalChecks />} />
            <Route path=":currentId" element={<CriticalCheckForm />} />
          </Route>
          <Route path="labour">
            <Route index element={<Labour />} />
            <Route path=":currentId" element={<LabourForm />} />
          </Route>
          <Route path="mobile-assets">
            <Route index element={<MobileAssets />} />
            <Route path=":currentId" element={<MobileAssetForm />} />
          </Route>
          <Route path="crews">
            <Route index element={<Crews />} />
            <Route path="Add" element={<CrewsForm />} />
            <Route path=":currentId" element={<CrewsDashboard />} />
          </Route>
          <Route path="company">
            <Route index element={<CompanyProfile />} />
          </Route>
          <Route path="layout">
            <Route index element={<LayoutDashboard />} />
          </Route>
        </Route>
        <Route path="/login/success" element={<LoginProcess />} />
        <Route path="/login/failed" element={<Login />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
